import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import LOGO from '../../assets/images/igboezenorthlga.png';
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [deptDropdownOpen, setDeptDropdownOpen] = useState(false);
  const [govDropdownOpen, setGovDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (menuOpen) {
      setDeptDropdownOpen(false);
      setGovDropdownOpen(false);
    }
  };

  const toggleDeptDropdown = () => {
    setDeptDropdownOpen(!deptDropdownOpen);
    setGovDropdownOpen(false);
  };

  const toggleGovDropdown = () => {
    setGovDropdownOpen(!govDropdownOpen);
    setDeptDropdownOpen(false);
  };

  const closeAll = () => {
    setMenuOpen(false);
    setDeptDropdownOpen(false);
    setGovDropdownOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-wrapper">
        <div className="navbar-logo">
          <Link to="/">
          <img src={LOGO} alt='Igbo-Eze North Local Goverment Area' />
          <h4>Igbo-Eze North</h4>
          </Link>
        </div>

        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={closeAll}>Home</Link></li>
          <li><Link to="/about" onClick={closeAll}>About</Link></li>
          <li><Link to="/our-team" onClick={closeAll}>Our Team</Link></li>

          <li className="dropdown">
            <div className="dropdown-toggle" onClick={toggleDeptDropdown}>
              Departments <FaChevronDown className={`arrow ${deptDropdownOpen ? 'rotate' : ''}`} />
            </div>
            {deptDropdownOpen && (
              <ul className="navbar-dropdown-menu">
                <li><Link to="/administration" onClick={closeAll}>Administration</Link></li>
                <li><Link to="/finance-accounts" onClick={closeAll}>Finance & Accounts</Link></li>
                <li><Link to="/works-housing" onClick={closeAll}>Works & Housing</Link></li>
                {/* <li><Link to="/planning-prs" onClick={closeAll}>Planning, Research & Statistics (PRS)</Link></li> */}
                <li><Link to="/reports" onClick={closeAll}>Planning, Budget & Development Reports</Link></li>
                <li><Link to="/health" onClick={closeAll}>Health Care</Link></li>
                <li><Link to="/security-safety" onClick={closeAll}>Security & Safety</Link></li>
                <li><Link to="/agriculture" onClick={closeAll}>Agriculture & Veterinary</Link></li>
                <li><Link to="/wash" onClick={closeAll}>WASH</Link></li>
                <li><Link to="/education" onClick={closeAll}>Education & Community Development</Link></li>
              </ul>
            )}
          </li>

          <li className="dropdown">
            <div className="dropdown-toggle" onClick={toggleGovDropdown}>
              Governance <FaChevronDown className={`arrow ${govDropdownOpen ? 'rotate' : ''}`} />
            </div>
            {govDropdownOpen && (
              <ul className="navbar-dropdown-menu">
                <li><Link to="/administrative-structure" onClick={closeAll}>Administrative Structure</Link></li>
                <li><Link to="/mtdp" onClick={closeAll}>Medium Term Development Plan</Link></li>
                <li><Link to="/ongoing-projects" onClick={closeAll}>Ongoing Projects</Link></li>
                <li><Link to="/public-services" onClick={closeAll}>Public Services</Link></li>
                <li><Link to="/tender-procurement" onClick={closeAll}>Tender & Procurement</Link></li>
                <li><Link to="/reports" onClick={closeAll}>Budget & Finance</Link></li>
                <li><Link to="/community-engagement" onClick={closeAll}>Community Engagement</Link></li>
              </ul>
            )}
          </li>

          <li><Link to="/news-events" onClick={closeAll}>News & Events</Link></li>
          <li><Link to="/contact" onClick={closeAll}>Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;